export default __webpack_public_path__ + "static/media/ic-exclamation-outlined.18dc9087.svg";